<template>
  <v-dialog :value="dialogProp.show" persistent max-width="600">
    <v-card class="elevation-12">
      <v-toolbar :dark="$vuetify.theme.dark" color="primary">
        <v-toolbar-title>
          {{ $t('Редактирование настроек SMTP') }}
        </v-toolbar-title>
      </v-toolbar>
      <v-row v-if="!!generalError || isLoading" class="my-0 py-0 mx-1">
        <v-col cols="12">
          <v-progress-linear :active="isLoading" color="loader" indeterminate />
        </v-col>
        <v-col class="mx-1">
          <general-error v-if="!!generalError" />
        </v-col>
      </v-row>
      <v-card-text>
        <v-row class="pa-2">
          <v-col>
            <ValidationObserver ref="settings">
              <validatable-text-input
                  v-model="settings.host"
                  prepend-icon="dns"
                  :rules="{ required: true }"
                  :label="$t('Хост')" />
              <validatable-text-input
                  v-model="settings.port"
                  prepend-icon="dns"
                  :rules="{ required: true }"
                  :label="$t('Порт')"
                  data-type="int" />
              <validatable-text-input
                  v-model="settings.userName"
                  prepend-icon="dns"
                  :label="$t('Пользователь')" />
              <validatable-text-input
                  v-model="settings.password"
                  :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  prepend-icon="dns"
                  :label="$t('Пароль')"
                  :type="showPassword ? 'text' : 'password'"
                  @click:append="showPassword = !showPassword" />
              <validatable-text-input
                  v-model="settings.mailFrom"
                  prepend-icon="dns"
                  :rules="{ required: true }"
                  :label="$t('Адрес отправителя')" />
              <validatable-checkbox
                  v-if="isMainAdmin"
                  v-model="settings.ignoreServerCertificateValidation"
                  :readonly="isLoading"
                  rules="required"
                  :label="$t('Игнорировать проверку сертификата сервера')" />
              <validatable-mail-list
                  v-if="isMainAdmin"
                  v-model="settings.adminsEmails"
                  v-test="{ 'mail-list': 'email' }"
                  rules="required"
                  :label="$t('Адреса администраторов системы')" />
            </ValidationObserver>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-btn
            id="cancelBtn"
            v-test="{ btn: 'cancel' }"
            color="primary"
            @click.stop="cancel">
          {{ $t('Отмена') }}
        </v-btn>
        <v-btn
            id="continueBtn"
            v-test="{ btn: 'continue' }"
            color="primary"
            @click.stop="send">
          {{ $t('Изменить') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import GeneralError from '@/components/reused/common/GeneralError.vue'
  import ValidatableTextInput from '@/components/reused/ui/ValidatableTextInput.vue'
  import ValidatableMailList from '@/components/reused/ui/ValidatableMailList.vue'
  import ValidatableCheckbox from '@/components/reused/ui/ValidatableCheckbox.vue'

  import { mapActions } from 'vuex'
  import { SYSTEM_SETTINGS } from '@/constants/store.js'

  export default {
    components: {
      GeneralError,
      ValidatableTextInput,
      ValidatableMailList,
      ValidatableCheckbox
    },
    props: {
      dialogProp: {
        type: Object,
        default: () => {
          return {
            show: false,
            settings: null,
            callback: null
          }
        }
      }
    },
    data () {
      return {
        isLoading: false,
        showPassword: false,
        settings: {
          host: null,
          port: null,
          ignoreServerCertificateValidation: null,
          userName: null,
          password: null,
          mailFrom: null,
          adminsEmails: []
        }
      }
    },
    watch: {
      'dialogProp.settings': {
        immediate: true,
        handler (newValue) {
          this.mapFields(newValue)
        }
      }
    },
    methods: {
      ...mapActions(SYSTEM_SETTINGS.NAMESPACE, {
        editSMTPSettingsAction: SYSTEM_SETTINGS.ACTIONS.EDIT_SMTP_SETTINGS
      }),
      mapFields: function (settings) {
        for (const propName in this.settings) {
          this.settings[propName] = settings[propName]
        }
      },
      send: async function () {
        const result = await this.$refs.settings.validate()
        if (!result) {
          return
        }
        try {
          this.isLoading = true
          await this.editSMTPSettingsAction(this.settings)
          this.isLoading = false
          if (this.dialogProp.callback) {
            this.dialogProp.callback()
          }
          this.cancel()
        } catch (error) {
          this.isLoading = false
          this.throwIfUnknownError(error)
        }
      },
      cancel: function () {
        this.$emit('close')
      }
    }
  }
</script>
